// extracted by mini-css-extract-plugin
module.exports = {"fontWavehaus":"LeftPane2_fontWavehaus__2cIbd","fontPoppins":"LeftPane2_fontPoppins__2tVm2","contact":"LeftPane2_contact__3yiuC"};